import { http } from '../utils/http/index'

export class ParkApi {
  // 会议室 取消申请，取消订单，取消预订
  async setMettingReserve(params: any) {
    return http.post('/room/setMeetingReserve', params)
  }

  // 我的会议室申请列表，会议室申请详情
  async bookRoomDetail(params: any) {
    return http.get('/room/detail', params)
  }

  // 获取会议室列表
  async getRoomList(params: any) {
    return http.get('/room/getRoomList', params)
  }

  // 获取会议室详情
  async getRoomDetail(params: any) {
    return http.get('/room/getRoomDetail', params)
  }

  // 预约会议室申请
  async reserveRoom(params: any) {
    return http.post('/room/reserveRoom', params)
  }

  // 个人中心获取当前用户会议室申请
  async getMyReserved(params: any) {
    return http.get('/room/getMyReserved', params)
  }

  // 预支付订单
  async orderPrepay(params: any) {
    return http.post('/room/orderPrepay', params)
  }

  // 支付
  async payment(params: any) {
    return http.post('/room/payment', params)
  }

  // 微信支付
  async wxPay(params: any) {
    return http.post('/room/wxPay', params)
  }

  // 取消预约
  async cancelBooking(params: any) {
    return http.post('/room/cancelBooking', params)
  }

  // 获取房源列表
  async getEstateList(params: any) {
    return http.get('/room-estate/getList', params)
  }

  // 获取房源详情
  async getEstateDetail(params: any) {
    return http.get('/room-estate/detail', params)
  }

  // 房源申请
  async getEstateApply(params: any) {
    return http.post('/room-estate/apply', params)
  }
  // 提交找房需求
  async submitEstateRequire(params: any) {
    return http.post('/room-estate/requirement', params)
  }
}
